export default __webpack_public_path__ + "static/media/Bloodbane.bd2c8edd.jpg";